import { Dispatch } from "@reduxjs/toolkit";
import {
  setActiveTab,
  setBookedData,
  setEnquiredData,
  setRecentlyViewedData,
  setShortlistedData,
  setShortlistedCount,
  setShortlistedPageCount,
} from "./activityPageReducer";

class ActivityPageDispatcher {
  private dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  updateActiveTab(data: any) {
    this.dispatch(setActiveTab(data));
  }

  updateShortlistedList(data: any) {
    this.dispatch(setShortlistedData(data));
  }

  updateShortlistedListCount(data: any) {
    this.dispatch(setShortlistedCount(data));
  }

  updateShortlistedPageCount(data: any) {
    this.dispatch(setShortlistedPageCount(data));
  }

  updateRecentlyViewedList(data: any) {
    this.dispatch(setRecentlyViewedData(data));
  }

  updateEnquiredList(data: any) {
    this.dispatch(setEnquiredData(data));
  }

  updateBookedList(data: any) {
    this.dispatch(setBookedData(data));
  }
}
export default ActivityPageDispatcher;
